"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var blog_module_1 = require("../../utils/shopify-graphql/blog-module");
var path_1 = require("../../utils/shopify/path");
var CtaButton_1 = require("../common/Btn/CtaButton");
var BlogModule = function () {
    var _a = (0, hooks_1.useState)(null), blogsData = _a[0], setBlogsData = _a[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, blog_module_1.getBlogsData)(handle, pathType)
            .then(function (data) { return setBlogsData(data); })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (!blogsData && location.pathname == '/') {
        setBlogsData({
            blogs: [
                {
                    id: 'gid://shopify/Article/561725898901',
                    image: {
                        url: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/articles/Untitled-1.png?v=1675796211',
                    },
                    onlineStoreUrl: 'https://opositiv.com/blogs/blog/what-your-vaginal-discharge-is-telling-you-about-your-health',
                    title: 'What Your Vaginal Discharge is Telling You About Your Health',
                },
                {
                    id: 'gid://shopify/Article/562436767893',
                    image: {
                        url: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/articles/MENOxLIBIDO.jpg?v=1683065621',
                    },
                    onlineStoreUrl: 'https://opositiv.com/blogs/blog/how-menopause-affects-sex-drive-libido',
                    title: 'How Menopause Affects Sex Drive & Libido',
                },
                {
                    id: 'gid://shopify/Article/562869567637',
                    image: {
                        url: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/articles/BLOG-IMG_1.jpg?v=1714516480',
                    },
                    onlineStoreUrl: 'https://opositiv.com/blogs/blog/what-is-the-best-diet-for-pcos',
                    title: 'What Is The Best Diet For PCOS?',
                },
            ],
            theme: {
                text: 'white',
                hover: 'gogo-orange',
                backgroundStart: 'gogo-orange',
                backgroundEnd: 'gogo-pale-orange',
            },
        });
    }
    if (blogsData) {
        return ((0, preact_1.h)("div", { class: "blog-module" },
            (0, preact_1.h)("div", { class: "blog-module__info" },
                (0, preact_1.h)("p", { class: "blog-module__header" }, "The Daily Vitamin"),
                (0, preact_1.h)("p", { class: "blog-module__subheader" },
                    "Get a daily serving of period hacks, ",
                    (0, preact_1.h)("br", null),
                    "self-care practices, and frequently ",
                    (0, preact_1.h)("br", null),
                    "asked health questions on our blog."),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("a", { class: "blog-module__explore", href: "https://opositiv.com/blogs/blog" }, "Explore More"),
                    ' ',
                    "\u2192"),
                (0, preact_1.h)("div", { class: "hide-on-mobile" },
                    (0, preact_1.h)(CtaButton_1.default, __assign({ text: "SHOP NOW", textColor: blogsData.theme.text, backgroundColor: {
                            to: 'Left',
                            startColor: blogsData.theme.backgroundStart || 'white',
                            endColor: blogsData.theme.backgroundEnd || 'white',
                        }, hoverColor: blogsData.theme.hover || 'white' }, (location.pathname.includes('tracking') || location.pathname == '/'
                        ? { scrollTo: 'https://opositiv.com/collections/shop-all' }
                        : {}))))),
            (0, preact_1.h)("div", { class: "blog-module__posts" },
                (0, preact_1.h)(preact_1.Fragment, null, blogsData.blogs.map(function (blog) {
                    var _a;
                    return ((0, preact_1.h)("div", { class: "blog-module__post", key: blog.id },
                        (0, preact_1.h)("img", { class: "blog-module__image", src: (_a = blog.image) === null || _a === void 0 ? void 0 : _a.url, alt: "", loading: window.isLazyVPTest ? 'lazy' : 'eager' }),
                        (0, preact_1.h)("div", { class: "blog-module__post-info" },
                            (0, preact_1.h)("div", { class: "blog-module__title" }, blog.title),
                            blog.onlineStoreUrl && ((0, preact_1.h)("div", null,
                                (0, preact_1.h)("a", { class: "blog-module__read", href: blog.onlineStoreUrl }, "Read More"),
                                ' ',
                                "\u2192")))));
                })),
                (0, preact_1.h)("div", { class: "hide-on-desktop" },
                    (0, preact_1.h)(CtaButton_1.default, { text: "SHOP NOW", textColor: blogsData.theme.text, backgroundColor: {
                            to: 'Left',
                            startColor: blogsData.theme.backgroundStart || 'white',
                            endColor: blogsData.theme.backgroundEnd || 'white',
                        }, hoverColor: blogsData.theme.hover || 'white', scrollTo: location.pathname == '/' ? '/collections/shop-all' : '#anchor--product-title' })))));
    }
    else {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
};
exports.default = BlogModule;
